import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableFormGroup = ({ setCuentaContableSeleccionada, cuentaContableSeleccionada, setCuentaInfo, cuentaContableInfo }) => {
  const onChange = React.useCallback(
    salida => {
      setCuentaContableSeleccionada(salida.value)
      setCuentaInfo(salida.label)
    },
    [setCuentaContableSeleccionada, setCuentaInfo]
  )

  const clickClear = React.useCallback(() => {
    setCuentaContableSeleccionada('')
    setCuentaInfo('')
  }, [setCuentaContableSeleccionada, setCuentaInfo])

  return (
    <Form.Group>
      <Form.Label text='CUENTA' htmlFor='select-cuentaContable' md={2} alignRightAt='md' />
      <Col md={10}>
        {cuentaContableSeleccionada ? (
          <ClearInputGroup id='cuentaContable' iValue={cuentaContableInfo} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-cuentaContable' onlyAnalitica onChange={onChange} />
        )}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
